export const brandAssetsEndpoint = `brand-assets`;
